import { Close } from "@mui/icons-material";
import { Box, IconButton, Snackbar } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "app/redux-store-interactions";
import { explorerActions, selectShowUnusuallyFarObjects } from "slices/explorer";

export function UnusuallyFarObjectsMessage() {
    const { t } = useTranslation();
    const show = useAppSelector(selectShowUnusuallyFarObjects);
    const dispatch = useAppDispatch();

    if (!show) {
        return null;
    }

    const close = () => {
        dispatch(explorerActions.setShowUnusuallyFarObjects(false));
    };

    return (
        <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            sx={{
                width: { xs: "auto", sm: 350 },
                bottom: { xs: "auto", sm: 88 },
                top: { xs: 24, sm: "auto" },
                pointerEvents: "auto",
            }}
            open={true}
            onClose={close}
            message={
                <>
                    <Box mb={1}>{t("unusuallyFarObjectsTitle")}</Box>
                    <Box fontWeight={400}>{t("unusuallyFarObjectsDescription")}</Box>
                </>
            }
            action={
                <IconButton aria-label="close" color="inherit" sx={{ p: 0.5 }} onClick={close}>
                    <Close />
                </IconButton>
            }
        />
    );
}
